<div class="grid">
    <div class="col-12">
        <div class="card">
            <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
                <h5>Change Password</h5>
                <div class="field grid">
                    <label htmlFor="currentPassword" class="col-12 mb-2 md:col-3">Current Password</label>
                    <div class="col-12 md:col-9">
                        <p-password formControlName="currentPassword" [toggleMask]="true" [feedback]="false" />
                        <div *ngIf="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched"
                            class="error-message text-red-600">
                            Current Password is required.
                        </div>
                    </div>
                </div>
                <div class="field grid">
                    <label htmlFor="newPassword" class="col-12 mb-2 md:col-3 md:mb-0">New Password</label>
                    <div class="col-12 md:col-9">
                        <p-password formControlName="newPassword" [toggleMask]="true" (keydown)="preventSpace($event)"
                            [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'"
                            appendTo="body">
                            <ng-template pTemplate="footer">
                                <p-divider />
                                <p class="mt-2">Password must contain</p>
                                <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                    <li>At least one lowercase</li>
                                    <li>At least one uppercase</li>
                                    <li>At least one numeric</li>
                                    <li>Minimum 8 characters</li>
                                </ul>
                            </ng-template>
                        </p-password>
                        <div *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched"
                            class="error-message text-red-600">
                            <div *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched"
                                class="error-message text-red-600">
                                <div *ngIf="passwordForm.get('newPassword')?.hasError('required')">New Password is
                                    required.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field grid">
                    <label htmlFor="confirmPassword" class="col-12 mb-2 md:col-3 md:mb-0">Confirm Password</label>
                    <div class="col-12 md:col-9">
                        <p-password formControlName="confirmPassword" [toggleMask]="true" [feedback]="false" />
                        <div *ngIf="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched"
                            class="error-message text-red-600">
                            Confirm Password is required.
                        </div>
                        <div *ngIf="passwordForm.hasError('passwordMismatch') && passwordForm.get('confirmPassword')?.touched"
                            class="error-message text-red-600">
                            Passwords do not match.
                        </div>
                    </div>
                </div>
                <button pButton label="Submit" type="submit" [disabled]="passwordForm.invalid"></button>
            </form>
        </div>
    </div>
</div>